import { sizes } from 'style';
import { th } from 'style/theme';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-top: 16px;

  @media ${sizes.desktop} {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

const Button = styled.button`
  display: flex;
  padding: 8px 16px;
  border-radius: 12px;
  cursor: pointer;
  width: 100%;
  justify-content: center;
  box-shadow: none;
  border: none;
  font-size: 16px;
  font-weight: 500;

  @media ${sizes.desktop} {
    width: fit-content;
  }
`;

export const CancelButton = styled(Button)`
  background-color: ${th('colors.white')};
  color: ${th('colors.pickledBluewood')};
`;

export const StartYourClaimButton = styled(Button)`
  background-color: ${th('colors.pickledBluewood')};
  color: ${th('colors.white')};

  :hover {
    background-color: ${th('colors.pickledBluewood-2')};
  }
`;
